exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-0875bf4b] {\n  bottom: 0;\n}\n#footerMovil[data-v-0875bf4b] {\n  display: none;\n}\n.cc-1xry[data-v-0875bf4b] {\n  bottom: 80px !important;\n}\n@media (min-width: 1200px) {\n.container[data-v-0875bf4b] {\n    max-width: 98% !important;\n}\n}\n@media screen and (max-width: 846px) {\nfooter[data-v-0875bf4b] {\n    position: absolute;\n    width: 100%;\n}\n#footerDesktop[data-v-0875bf4b] {\n    display: none;\n}\n#footerMovil[data-v-0875bf4b] {\n    display: block;\n}\n}", ""]);

// exports
